import { render, staticRenderFns } from "./MenuInvIntMgmt.vue?vue&type=template&id=a4594e52&"
import script from "./MenuInvIntMgmt.vue?vue&type=script&lang=js&"
export * from "./MenuInvIntMgmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports